import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/codebuild/output/src879763043/src/codemochi-courses/src/components/routes/public/Lecture.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div className="objective">
  <p>
    <span>Objective:</span> Add the start of our create recipe form component.
  </p>
    </div>
    <p>{`Now that we have a create recipe route, let's create the component that will contain the form for editing a recipe. For now, the form will only have a submit button and we will manage the state of the form through a submitForm hook.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-components/CreateRecipe.tsx"
      }}>{`import { Row, Col, Form, Button } from 'antd';
import { submitForm } from '../utils/submitForm';

export const CreateRecipe = () => {
  const initiateCreateRecipe = () => {
    console.log('submitted form');
  };

  const { inputs, handleSubmit } = submitForm({}, initiateCreateRecipe);

  return (
    <Form onFinish={handleSubmit}>
      <Row>
        <Col span={16} />
        <Col span={4}>
          <Form.Item label="Create Recipe">
            <Button type="primary" htmlType="submit">
              Create Recipe
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

`}</code></pre>
    <p>{`The submit form hook works by storing the state within a useState hook in react. We can call `}<inlineCode parentName="p">{`setInputs`}</inlineCode>{` to set the current state of the hook and `}<inlineCode parentName="p">{`inputs`}</inlineCode>{` for reading the state. We can pass in an intialValues object which will have all of the default values that the form will use, as well as a callback function which will enable us to have the `}<inlineCode parentName="p">{`submitForm`}</inlineCode>{` hook execute functionality that we define in the `}<inlineCode parentName="p">{`<CreateRecipe>`}</inlineCode>{`. After executing the callback, we reset the form back to its default state.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-utils/submitForm.ts"
      }}>{`import { useState } from 'react';

export const submitForm = (initialValues, callback) => {
  const [inputs, setInputs] = useState(initialValues);

  const handleSubmit = () => {
    callback();
    setInputs(() => ({ ...initialValues }));
  };

  return {
    inputs,
    handleSubmit,
  };
};

`}</code></pre>
    <p>{`Now that the `}<inlineCode parentName="p">{`<CreateRecipe>`}</inlineCode>{` component has been created, let's use it on the create page:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pages/create.tsx"
      }}>{`import { MainLayout } from '../components/layout/MainLayout';
import styled from 'styled-components';
import { CreateRecipe } from '../components/CreateRecipe';

const StyledHeader = styled.h1\`
  \${({ theme }) => \`
        padding: \${theme['padding-small']} \${theme['padding-small']};
    \`}
\`;

const Create = () => {
  return (
    <MainLayout title="Create Recipe">
      <StyledHeader>Create Recipe</StyledHeader>
      <CreateRecipe />
    </MainLayout>
  );
};

export default Create;

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      